export const eventPopState = "popstate";
export const eventPushState = "pushState";
export const eventReplaceState = "replaceState";
export const historyEvents = [eventPopState, eventPushState, eventReplaceState];
